import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

//Component
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';
import NovoInscricoesMunicipais from './NovoInscricoesMunicipais';
import TextField from '../../components/TextField/TextField';

//API
import inscricaoMunicipal_api from '../../api/inscricaoMunicipal_api';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';

function FichaInscricoesMunicipais({ btnVoltar, id = null, filtro }) {
  const [inscricaoMunicipal, setInscricaoMunicipal] = useState(null);

  // guarda o estado para a exibição do loading na tela
  const [loading, setLoading] = useState(false);

  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setLoading(true);
    inscricaoMunicipal_api.GetItem(id).then(response => {
      setInscricaoMunicipal(response.data)
    }).catch(error => showMessage("Error", error.message, "error", null))
      .finally(() => setLoading(false))
  }, []);

  if (edit && inscricaoMunicipal) {
    return <NovoInscricoesMunicipais
      btnVoltar={btnVoltar}
      inscricaoMunicipal={inscricaoMunicipal}
      filtro={filtro}
    />
  }

  return <>
    {loading && <Loading />}
    <MainCard btnVoltar={btnVoltar} btnEditar={() => setEdit(true)} >
      {inscricaoMunicipal &&
        <>
          <Row>
            <Col md={"12"} lg={"4"}>
              <TextField
                maxLength={"18"}
                label={"* CNPJ"}
                value={inscricaoMunicipal.cnpj}
                name="cnpj"
                mask={mascaras.cpfcnpjMask}
                disabled={true}
              />
            </Col>
            <Col md={"12"} lg={"4"}>
              <TextField
                maxLength={"50"}
                label={"* Razão Social"}
                value={inscricaoMunicipal.razaoSocial}
                name="razaoSocial"
                disabled={true}
              />
            </Col>
            <Col md={"12"} lg={"4"}>
              <TextField
                maxLength={"14"}
                label={"* Inscrição Municipal"}
                value={inscricaoMunicipal.inscricaoMunicipal}
                name="inscricaoMunicipal"
                disabled={true}
              />
            </Col>
          </Row>
        </>
      }
    </MainCard>
  </>
}

export default FichaInscricoesMunicipais;